import {Button, Col, FormGroup, Label, Row} from "reactstrap";
import {I18n} from "../../I18n/components/promoter";
import Datetime from "react-datetime";
import React from "react";

const DateTimeRow = props => {
    const {lang, fieldName, label, value, timeFormat, validator} = props;

    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for={fieldName}>{label}</Label>
                    <Datetime
                        id={fieldName}
                        className="promoter-data-filter"
                        locale={lang}
                        timeFormat={timeFormat}
                        dateFormat={false}
                        inputProps={{
                            placeholder: timeFormat,
                            readonly: true
                        }}
                        onChange={value => props.onChange(fieldName, value, timeFormat)}
                        closeOnSelect={true}
                        value={value}
                    />
                    <Button
                        color="primary"
                        type="button"
                        className="ml-2"
                        onClick={() => props.onChange(fieldName, null)}
                    >
                        {I18n[lang].reset}
                    </Button>
                    {validator.showErrors(fieldName)}
                </FormGroup>
            </Col>
        </Row>
    );
}

export default DateTimeRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/DateTimeRow.js